import { NgModule } from '@angular/core';
import { RouterModule, Routes, Route, UrlSegment } from '@angular/router';

import { LoginComponent } from './login/login.component';

import { NotFoundComponent } from './error/not-found/not-found.component'

import { AuthGuard } from './auth.guard'
import { SharedModule } from './shared/shared.module';
import { UserRoles } from './models/user-roles';

export const routes: Routes = [
  { path: '', redirectTo: '/site/list/-1', pathMatch: 'full', canActivate:[AuthGuard] },


  { path: 'login', component: LoginComponent },


  {
    path: '',
    loadChildren: './site-view/site-view.module#SiteViewModule',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data:{roles:[UserRoles.admin, UserRoles.user, UserRoles.viewOnly, UserRoles]}
  },


  {
    path: 'management',
    loadChildren: './system-management/system-management.module#SystemManagementModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
    data:{roles:[UserRoles.admin, UserRoles.user, UserRoles.userManager]}
  },

  {
    path: 'dashboard',
    loadChildren: './dashboard-view/dashboard-view.module#DashboardViewModule',
    canActivate: [AuthGuard],
    canLoad: ['canViewDashboard'],
    data:{roles:[UserRoles.admin, UserRoles.user, UserRoles.viewOnly]}
  },

  {
    path: 'reports',
    loadChildren: './reports-view/reports-view.module#ReportsViewModule',
    canActivate: [AuthGuard],
    data:{roles:[UserRoles.admin, UserRoles.user, UserRoles.viewOnly]}
  },


  { path: '**', component: NotFoundComponent }
];

@NgModule({
  declarations:[

  ],
  imports: [RouterModule.forRoot(routes, { enableTracing: false, useHash: true }), SharedModule],
  providers: [
    {
      // Create custom provider to check if a user can view the dashboard
      provide: 'canViewDashboard',
      useValue: (route: Route, segments: UrlSegment[]) => {
        let user = JSON.parse(localStorage.getItem('USER'));
        if (user) {          
          if (user.roles.includes("ROLE_ADMIN") || user.roles.includes("ROLE_USER")) {
                return true;
            }
        }
        //show some not authorized message
        return false;
      }
    }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
